import { FC } from 'react';
import { PreloaderWrapperProps } from '../types';

export const PreloaderWrapper: FC<PreloaderWrapperProps> = ({ children }) => {
	return <div>{children}</div>;
};
